module.exports = __webpack_public_path__ + "components/cityspotters-story/static/enjoy-bb334ab3389881aa43e40a2c586049f4.svg";